import { useFormik } from 'formik'
import React, {useContext, SetStateAction} from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import useCallRestApi from '../../../hooks/useCallRestApi'
import { BodyContext } from '../../../contexts/BodyProvider'

type Props = {
    show: boolean,
    closeModal: (value: boolean) => void,
    setCategoriesBI: React.Dispatch<SetStateAction<CategoryBI[]>>,
    cardsBI: CardsConectaBI[],
    setCardsBI: (values: CardsConectaBI[]) => void,
    categoriesBI: CategoryBI[]
}

function ModalEditCategoryBI({show, closeModal, setCategoriesBI, cardsBI, setCardsBI}: Props) {
  const { categoryBIValue, loadingAdminBIValue } = useContext(BodyContext);
  const [conectaApi] = useCallRestApi()

  const formikCategoryBI = useFormik({
    initialValues: {
        id: categoryBIValue!.categoryBI![0].id as number,
        name: categoryBIValue!.categoryBI![0].name as string,
        color: categoryBIValue!.categoryBI![0].color as string,
        slug: categoryBIValue!.categoryBI![0].slug as string,
    },
    onSubmit: values => {
        //console.log(JSON.stringify(values, null, 2))
        const link: ResourceLink = {
            href: `api/category_bi/${categoryBIValue!.categoryBI![0].id}`,
            rel: "Atualizar",
            type: "PUT",
          };
           conectaApi<CategoryBI>({
            link,
            resource: values,
            onSuccess: () => {
                loadingAdminBIValue?.setLoadingAdminBI(true)
                updateCardColor(categoryBIValue!.categoryBI![0].id, formikCategoryBI.values.color)
                renderList()
                loadingAdminBIValue?.setLoadingAdminBI(false)                
            },
            onError: (err: ErrorApi) => {},
            onFinally: () => {
              handleClose()
            },
          })
    }
})
const updateCardColor = (id_category: number, categoryColor: string) => {
  const link: ResourceLink = {
    href: `api/card_bi/update_by_category/${id_category}`,
    rel: "Atualizar",
    type: "PUT",
  };
  conectaApi({
    link,
    resource: {color: categoryColor},
    onSuccess: () => {
      renderCards()
    },
    onError: (err: ErrorApi) => {},
    onFinally: () => {
      handleClose()
       
    },
  })
}
const renderList = () => { 
    const link: ResourceLink = {
      href: `api/category_bi`,
      rel: "search",
      type: "GET",
    };

    conectaApi<CategoryBI[]>({
      link,
      onSuccess: (categoriesBI: CategoryBI[]) => {
        loadingAdminBIValue?.setLoadingAdminBI(true)
        setCategoriesBI(categoriesBI);
        loadingAdminBIValue?.setLoadingAdminBI(false)
      },
      onError: (err: ErrorApi) => {},
      onFinally: () => {},
    });
  };

  const renderCards = () => { 
    const link: ResourceLink = {
      href: `api/card_bi`,
      rel: "search",
      type: "GET",
    };

    conectaApi<CardsConectaBI[]>({
      link,
      onSuccess: (cardBI: CardsConectaBI[]) => {
        setCardsBI(cardBI);
      },
      onError: (err: ErrorApi) => {},
      onFinally: () => {},
    });
  };

  const handleClose = () => closeModal(false)
  
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Editar Categorias BI</Modal.Title>
        </Modal.Header>
        <Form onSubmit={formikCategoryBI.handleSubmit}>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        placeholder="Nome da categoria"
                        value={formikCategoryBI.values.name}
                        onChange={formikCategoryBI.handleChange}
                    />
                </Form.Group>
                <Form.Group>
                <Form.Label htmlFor="color">Cor</Form.Label>
                    <Row>
                    <Col>
                        <Form.Control
                            type="color"
                            id="color"
                            name="color"
                            value={formikCategoryBI.values.color}
                            onChange={formikCategoryBI.handleChange}
                        />
                    </Col>
                    <Col>
                    <Form.Control
                        id="color"
                        type="text"
                        name="color"
                        value={formikCategoryBI.values.color}
                        onChange={formikCategoryBI.handleChange}
                        disabled
                    />
                    </Col>
                </Row>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type="submit">Atualizar</Button>
                <Button variant="danger" onClick={handleClose}> Fechar</Button>
            </Modal.Footer>
        </Form>
    </Modal>
  )
}

export default ModalEditCategoryBI